import Joi from '@hapi/joi'


export const employeeTaskFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),

    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity ").messages({
        "any.invalid": `Please Select the Valid Operation Entity`,
        "any.required": `Operation Entity required`
    }),

    collectionPointID: Joi.number().invalid(0).required().label("Collection Point ").messages({
        "any.invalid": `Please Select the Valid Collection Point`,
        "any.required": `Collection Point required`
    }),
    date: Joi.string().invalid("").label("Date"),
    

    employeeID: Joi.number().invalid().required().label("Employee Name").messages({
        "any.invalid": `Please Select the Valid Employee Name`,
        "any.required": `Employee Name required`
    })


    
}















